import { Link } from 'react-router-dom';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-[#2C3E50] text-white">
      <div className="max-w-7xl mx-auto px-6 py-12">
        <div className="grid md:grid-cols-3 gap-8 mb-8">
          {/* Company Info */}
          <div className="md:col-span-2">
            <img 
              src="https://i.imgur.com/x9sWirr.png" 
              alt="Logo" 
              className="h-24 w-auto mb-6"
            />
            <p className="text-gray-300 mb-4 leading-relaxed">
              Red de distribuidoras asociadas con Bachoco, líder en la industria avícola de México. 
              Garantizamos frescura, calidad y el mejor servicio.
            </p>
            <div className="flex gap-4">
              <a 
                href="https://facebook.com" 
                target="_blank" 
                rel="noopener noreferrer"
                className="w-10 h-10 flex items-center justify-center bg-white/10 hover:bg-[#FF6B35] rounded-full transition-all duration-300 cursor-pointer"
              >
                <i className="ri-facebook-fill text-xl"></i>
              </a>
              <a 
                href="https://instagram.com" 
                target="_blank" 
                rel="noopener noreferrer"
                className="w-10 h-10 flex items-center justify-center bg-white/10 hover:bg-[#FF6B35] rounded-full transition-all duration-300 cursor-pointer"
              >
                <i className="ri-instagram-line text-xl"></i>
              </a>
              <a 
                href="https://wa.me/5215512345678" 
                target="_blank" 
                rel="noopener noreferrer"
                className="w-10 h-10 flex items-center justify-center bg-white/10 hover:bg-[#25D366] rounded-full transition-all duration-300 cursor-pointer"
              >
                <i className="ri-whatsapp-line text-xl"></i>
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-bold mb-4 text-[#FF6B35]">Enlaces Rápidos</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-gray-300 hover:text-[#FF6B35] transition-colors cursor-pointer">
                  Inicio
                </Link>
              </li>
              <li>
                <Link to="/productos" className="text-gray-300 hover:text-[#FF6B35] transition-colors cursor-pointer">
                  Productos
                </Link>
              </li>
              <li>
                <Link to="/sucursales" className="text-gray-300 hover:text-[#FF6B35] transition-colors cursor-pointer">
                  Sucursales
                </Link>
              </li>
              <li>
                <Link to="/nosotros" className="text-gray-300 hover:text-[#FF6B35] transition-colors cursor-pointer">
                  Nosotros
                </Link>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-white/10 pt-8 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-gray-400 text-sm text-center md:text-left">
            © {currentYear} ML Grupo Comercial. Todos los derechos reservados.
          </p>
          <a 
            href="https://mycleth.com.mx/" 
            target="_blank" 
            rel="noopener noreferrer"
            className="text-gray-400 hover:text-[#FF6B35] text-sm transition-colors cursor-pointer"
          >
            Powered by Mycleth
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
